import React from 'react';
import { connect } from 'react-redux';
import { t } from '../../../services/i18nService';
import annotationService from '../../../services/AnnotationService';
import AnnotationItem from '../annotationItem/AnnotationItem';
import styles from './annotationList.scss';
import annotationListSelector from '../../../selectors/annotationsSidebar/annotationList/AnnotationListSelector';

const AnnotationList = ({ notes }) => {
    const renderEmptyList = () => (
        <div className={styles.emptyList}>
            <div className={styles.emptyListContainer}>
                <div className={styles.emptyListTitle}>{t('annotations.willShowHere')}</div>
                <div className={styles.emptyListDescription}>{t('annotations.selectAnyText')}</div>
            </div>
        </div>
    );

    const renderList = () => {
        return (
            <ul className={styles.annotationsList} id="annotations-list">
                { notes.map(item => (
                    <AnnotationItem
                        comment={item.note}
                        content={annotationService.getQuote(item)}
                        contentId={item.data.contentId}
                        focused={annotationService.isFocused(item.selector)}
                        key={item.id}
                        number={item.data.number}
                        scorableItem={item.data.scorableItem}
                        sectionId={item.data.sectionId}
                        selector={item.selector}
                        type={item.data.type}
                    />
                ))}
            </ul>
        );
    };

    return (notes.length > 0) ? renderList() : renderEmptyList();
};

const mapStateToProps = state => annotationListSelector.selectProps(state);
export default connect(mapStateToProps)(AnnotationList);
